"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiRadio = getMuiRadio;
function getMuiRadio(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        '&.Mui-disabled': {
          '&:hover': {
            backgroundColor: palette.grey[100]
          },
          color: palette.grey[300]
        },
        '&:hover': {
          backgroundColor: palette.primary.light
        }
      }
    }
  };
}